



















import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'

@Component
export default class ActionBar extends Vue {
  @Prop()
  title: {
    required: true;
    type: string;
  }
  @Prop()
  back: boolean;

  public goBack (): void {
    window.history.back()
  }
}

